import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { authorizedPyInstance as py } from '~/utils';

const TableFilterIdentitySource = ({
  onChange,
}) => {
  const [hospitals, setHospitals] = useState([]);

  const [value, setValue] = useState([]);

  const setFilterValue = (e) => {
    setValue(e);
    if (e) {
      onChange(e.map(ee => ee.value));
    } else {
      onChange(undefined);
    }
  };

  useEffect(() => {
    py
      .get('api/data/public/list_view_cs_tbl_identity_source', {
        params: {
          is_primary_source_of_truth: false,
          sort: 'source_description',
        },
      })
      .then(r => r.data.data)
      .then((r) => {
        const h = r.map(rr => ({
          label: rr.attributes.sourceDescription,
          value: rr.attributes.sourceDescription,
        }));
        setHospitals(h);
      });
  }, []);

  return (
    <Select
      value={value}
      onChange={setFilterValue}
      options={hospitals}
      closeMenuOnSelect={false}
      menuPortalTarget={document.body}
      className="w-100 form-select pt-0 pb-2 px-0"
      classNamePrefix="react-select"
      isMulti
    />
  );
};

TableFilterIdentitySource.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default TableFilterIdentitySource;
